import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ObfuscatedEmail = ({ user, domain, className = "" }) => {
  const [revealed, setRevealed] = useState(false);
  const { t } = useTranslation();
  const email = `${user}@${domain}`;

  const handleClick = (e) => {
    if (!revealed) {
      e.preventDefault();
      setRevealed(true);
    }
  };

  return revealed ? (
    <a
      href={`mailto:${email}`}
      className={className}
      aria-label="Email contact"
    >
      {email}
    </a>
  ) : (
    <button
      onClick={handleClick}
      className={`${className} underline cursor-pointer bg-transparent border-none p-0 font-inherit`}
      aria-label="Click to reveal email"
    >
      {t('footer.clickToViewEmail', 'Click here to view email')}
    </button>
  );
};

export default ObfuscatedEmail;
